<template>
  <path
    d="M8.50001 8.62026V15.3803L5.12001 12.0003L8.50001 8.62026ZM3.71001 11.2903C3.32001 11.6803 3.32001 12.3103 3.71001 12.7003L8.30001 17.2903C8.92001 17.9203 10 17.4803 10 16.5903V7.41026C10 6.52026 8.92001 6.07026 8.29001 6.70026L3.71001 11.2903ZM14 7.41026V16.5803C14 17.4703 15.08 17.9203 15.71 17.2903L20.3 12.7003C20.69 12.3103 20.69 11.6803 20.3 11.2903L15.71 6.70026C15.08 6.08026 14 6.52026 14 7.41026Z"
  />
</template>
